import styled, {css} from 'styled-components';
import Close from '../../assets/onboarding/closeIcon.svg';

const CloseIcon = styled(Close as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.8rem'};
  height: ${props => props.height || '1.8rem'};
  display: flex;
  cursor: pointer;
`;

export default CloseIcon;
